export const STAGING_SUCCESS_REDIRECT = 'https://wesit13.we-nonprod.uscc.com/';
export const PRODUCTION_SUCCESS_REDIRECT = 'https://www.uscellular.com/';

export const QUERY_STRING_PREV_STEP_OVERRIDE: string = 'mockPreviousStep';
